export default __webpack_public_path__ + "static/media/fanAthleteSchoolCollectiveAd.199736f4.jpg";